<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-electrolyseur"
  [title]="'P0003607.dashboard.electrolyseur' | translate"
  [content]="
    buttonMode[this.actionStack!.getValue('esCModeFonctionnement')].icon!
  "
  [color]="
    buttonMode[this.actionStack!.getValue('esCModeFonctionnement')].color!
  "
  [status]="
    buttons[this.actionStack!.getValue('esSEtatSortieElectrolyseur')].title!
      | translate
  "
  [statusMode]="
    buttons[this.actionStack!.getValue('esSEtatSortieElectrolyseur')].status!
  "
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
